import React, { useEffect } from "react";

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Row,
  Col,
} from "reactstrap";

import {
  loginMethod,
  setLoggedIn,
  setLoginType,
  setUserEmail,
  setUserName,
  setUserB64,
  setUserId,
  setPswd,
} from "../../services/httpServices";
import { useToasts } from "react-toast-notifications";
import { useHistory } from "react-router";
import jwt_decode from "jwt-decode";
import { fetchSubs } from "../subscriber/action";
import { connect } from "react-redux";
import { setUserImage } from "./action";
import PhoneInput from "react-phone-input-2";
import OverImg from "../../assets/img/icons/common/Group-29.svg";

const Login = (props) => {
  const initialValue = {
    email: null,
    pswd: null,
  };

  const [values, setValues] = React.useState(initialValue);
  const [errors, setErrors] = React.useState(initialValue);
  const [showPswd, setShowPswd] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [loginOption, setLoginOption] = React.useState(""); // Initial option: 'mobile'

  const { addToast } = useToasts();
  const history = useHistory();

  const handleLoginOptionChange = (e) => {
    setValues({ ...values, email: "" });
    setLoginOption(e.target.value);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const validate = (inputs) => {
    let errors = {};
    let digiRegex = /^[0-9]*$/;
    if (!inputs.email) {
      errors.email = "Email address / mobile number is required";
    } else if (
      isNaN(inputs.email) &&
      !/\S+@\S+\.\S+/.test(inputs.email) &&
      !digiRegex.test(inputs.email)
    ) {
      errors.email = "* Email address / mobile number is invalid";
    }
    // else if (digiRegex.test(inputs.email) && inputs.email.length !== 11) {
    //   errors.email = ' * Mobile number should contain 11 digits';
    // }
    if (!inputs.pswd) {
      errors.pswd = "* Password is required";
    }
    return errors;
  };

  const notify = (text, type) => {
    if (!text) {
      text = "Save successfully";
    }
    if (!type) {
      type = "success";
    }
    addToast(text, {
      appearance: type,
      autoDismiss: true,
    });
  };

  const forgotPswd = (e) => {
    e.preventDefault();
    history.push("/forgot-password");
  };

  const signUp = (e) => {
    e.preventDefault();
    history.push("/sign-up");
  };

  const privacyPolicy = (e) => {
    e.preventDefault();
    history.push("/privacy-policy");
  };

  useEffect(() => {
    window.localStorage.setItem("validUser", false);
  }, []);

  const handleSubmit = (event) => {
    let errorMsg = "";
    event.preventDefault();
    const validationErrors = validate(values);
    setErrors(validationErrors);
    const noErrors = Object.values(validationErrors).every((x) => x === "");
    setErrors(validationErrors);
    const noDashboardUsers = [
      "Sales Supervisor",
      "Sales Representative",
      "Operation supervisor",
      "Operations Officer",
      "Audits and Compliance",
      "Customer Support Supervisor",
      "Customer Support Representative",
    ];
    if (noErrors) {
      setLoggedIn(false);
      let url = "/api/Auth/Login";
      if (loginOption === "") {
        notify("Please select the login option Mobile/Email", "error");
        return;
      }

      let data = {
        Email: values.email.trim(),
        Password: values.pswd,
      };
      setLoading(true);
      loginMethod(url, data, "post")
        .then((res) => {
          setLoading(false);
          if (res.data) {
            if (res.data.responseCode === "200") {
              if (res.data.result) {
                window.localStorage.setItem("token", res.data.result);
                window.localStorage.setItem("validUser", true);
                // setPswd(values.pswd);
                var decoded = jwt_decode(res.data.result);
                if (decoded && decoded.UserProfile) {
                  var userProfile = JSON.parse(decoded.UserProfile);
                  if (userProfile.hasOwnProperty("UserRole")) {
                    setLoginType(userProfile.UserRole);
                    // if (userProfile.UserRole === "Subscriber") {
                    //   fetchSubs();
                    // }
                  }

                  if (
                    userProfile.hasOwnProperty("UserName") &&
                    userProfile.UserName.length
                  ) {
                    setUserName(userProfile.UserName);
                  }

                  // if (
                  //   userProfile.hasOwnProperty('UserProfileImage') &&
                  //   userProfile.UserProfileImage &&
                  //   userProfile.UserProfileImage.length
                  // ) {
                  //   setUserB64(userProfile.UserProfileImage);
                  // } else {
                  //   setUserB64(null);
                  // }

                  if (
                    userProfile.hasOwnProperty("UserID") &&
                    userProfile.UserID.length
                  ) {
                    setUserId(userProfile.UserID);
                  }
                }
                setUserEmail(values.email);
                setLoggedIn(true);
                fetchUserInfo(userProfile.UserID);
                if (noDashboardUsers.includes(userProfile.UserRole)) {
                  history.push("/user-list");
                } else {
                  history.push("/index");
                }
              } else {
                errorMsg = "Token not found";
                notify(errorMsg, "error");
              }
            } else if (res.data.responseCode === "400") {
              errorMsg = res.data.responseMessage || "Invalid credentials";
              notify(errorMsg, "error");
            } else {
              errorMsg = "Error in login";
              notify(errorMsg, "error");
            }
          } else {
            errorMsg = "Unknown Error";
            notify(errorMsg, "error");
          }
        })
        .catch((err) => {
          setLoading(false);
          errorMsg = "Internal Server Error";
          notify(errorMsg, "error");
        });
    } else {
    }
  };

  const fetchSubs = () => {
    props.fetchSubsInfo();
  };

  const fetchUserInfo = (id) => {
    let errorMsg = "";
    // var id = 'c8a24293-7b55-4f6c-a930-5431947c25cd';
    loginMethod("/api/User/profileImage/" + id, {}, "get")
      .then((res) => {
        if (res && res.data && res.data.length) {
          setUserB64(res.data);
          props.setImg(true);
        } else {
          setUserB64(null);
          props.setImg(false);
        }
      })
      .catch((err) => {
        notifyFailed("Internal Server Error");
      });
  };

  const notifyFailed = (text) => {
    if (!text) {
      text = "Error in saving";
    }
    addToast(text, {
      appearance: "error",
      autoDismiss: true,
    });
  };

  const phoneChange = (value, data, event, formattedValue) => {
    if (data.dialCode && data.dialCode.length) {
      setValues({
        ...values,
        email: value,
      });
    }
    return;
  };

  return (
    <>
      <Col
        lg="5"
        md="7"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Card className=" shadow border-0 text-white text-black position-relative">
          {/* <img
            src={OverImg}
            alt=".."
            className="position-absolute top--5 z-1 right--6"
          /> */}
          <CardBody className="px-lg-5 py-lg-5">
            {/* <div className="text-center text-white mb-2">
              <small>Sign in with credentials</small>
            </div> */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
              }}
            >
              <img
                alt="..."
                src={require("../../assets/img/brand/lapologo.PNG").default}
                style={{ width: "120px", objectFit: "contain", height: "auto" }}
              />
            </div>
            <Form role="form" onSubmit={handleSubmit}>
              <div>
                <FormGroup className="mb-3 mt-3">
                  <label htmlFor="mobileOption" style={{ color: "black" }}>
                    Login Using &nbsp;
                  </label>

                  <label htmlFor="mobileOption" style={{ color: "black" }}>
                    <input
                      type="radio"
                      id="mobileOption"
                      name="mobileOption"
                      value="mobile"
                      checked={loginOption === "mobile"}
                      onChange={handleLoginOptionChange}
                    />
                    &nbsp;Mobile number &nbsp;{" "}
                  </label>

                  <label htmlFor="emailOption" style={{ color: "black" }}>
                    <input
                      type="radio"
                      id="emailOption"
                      name="emailOption"
                      value="email"
                      checked={loginOption === "email"}
                      onChange={handleLoginOptionChange}
                    />
                    &nbsp;Email
                  </label>
                </FormGroup>
              </div>
              <FormGroup className=" mt-3">
                {loginOption === "mobile" ? (
                  <PhoneInput
                    className="form-control-alternative"
                    country={"sl"}
                    enableSearch
                    value={values.phone}
                    countryCodeEditable={false}
                    onChange={phoneChange}
                  />
                ) : (
                  <>
                    <label htmlFor="emailOption" style={{ color: "black" }}>
                      Email Address
                    </label>

                    <InputGroup className="input-group-alternative">
                      <Input
                        placeholder="Email"
                        type="email"
                        autoComplete="new-email"
                        name="email"
                        value={values.email}
                        onChange={handleInputChange}
                        disabled={loginOption === ""}
                      />
                      <InputGroupAddon addonType="append">
                        <InputGroupText>
                          <i className="ni ni-email-83" />
                        </InputGroupText>
                      </InputGroupAddon>
                    </InputGroup>
                  </>
                )}

                {errors.email && (
                  <div className="text-left text-danger mb-1">
                    <small>{errors.email}</small>
                  </div>
                )}
              </FormGroup>
              <FormGroup>
                <label htmlFor="password" style={{ color: "black" }}>
                  Password
                </label>

                <InputGroup className="input-group-alternative">
                  <Input
                    placeholder="Password"
                    type={showPswd ? "text" : "password"}
                    autoComplete="new-password"
                    name="pswd"
                    value={values.pswd}
                    disabled={loginOption === ""}
                    onChange={handleInputChange}
                  />
                  {!showPswd && (
                    <InputGroupAddon addonType="append">
                      <InputGroupText>
                        <i
                          className="fa fa-eye"
                          onClick={() => setShowPswd(true)}
                        />
                      </InputGroupText>
                    </InputGroupAddon>
                  )}

                  {showPswd && (
                    <InputGroupAddon addonType="append">
                      <InputGroupText>
                        <i
                          className="fa fa-eye-slash"
                          onClick={() => setShowPswd(false)}
                        />
                      </InputGroupText>
                    </InputGroupAddon>
                  )}
                </InputGroup>
                {errors.pswd && (
                  <div className="text-left text-danger">
                    <small>{errors.pswd}</small>
                  </div>
                )}
                <br />
              </FormGroup>
              <div className="text-center">
                <Button
                  className="mb-4 text-white sign-up-btn w-100"
                  type="submit"
                  disabled={loading}
                >
                  Sign In {loading && <i class="fa fa-spinner fa-spin"></i>}
                </Button>
              </div>

              <Row>
                <Col
                  lg="12"
                  className="d-flex justify-content-center align-items-center w-100"
                  style={{ gap: "8px" }}
                >
                  <small>
                    <a
                      className="text-dark"
                      onClick={(e) => signUp(e)}
                      id="tag"
                      href="#"
                    >
                      <strong>Sign up</strong>
                    </a>
                  </small>
                  <small className="text-dark"> • </small>
                  <small style={{ color: "black" }}>
                    <a
                      className="text-dark"
                      onClick={(e) => privacyPolicy(e)}
                      id="tag"
                      href="#"
                    >
                      <strong>Privacy Policy</strong>
                    </a>
                  </small>
                  <small className="text-dark"> • </small>
                  <small style={{ color: "black" }}>
                    <a
                      className="text-dark"
                      onClick={(e) => forgotPswd(e)}
                      id="tag"
                      href="#"
                    >
                      <strong>Forgot Password?</strong>
                    </a>
                  </small>
                  {/* <small style={{ color: "black" }}>
                    <a
                      className="text-dark w-auto"
                      onClick={(e) => forgotPswd(e)}
                      id="tag"
                      href="#"
                    >
                      <strong>Forgot Password?</strong>
                    </a>
                  </small> */}
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

const mapStateToProps = (state) => {
  return { ...state };
};
const mapDispatchToProps = (dispatch) => {
  return {
    fetchSubsInfo: () => dispatch(fetchSubs()),
    setImg: (data) => dispatch(setUserImage(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
